import { Component, HostListener, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { throws } from 'assert';
import { ADN_PLUS, PlusException } from '../../models';
import { CtrlBaseComponent } from '../ctrl-base.component';
@Component({
  selector: 'my-ct-email-form',
  templateUrl: './ct-email-form.component.html',
  styleUrls: ['./ct-email-form.component.css'],
  host: { '[style.width]': "'100%'" }
})
export class CtEmailFormComponent extends CtrlBaseComponent {
  
  ADNRecipientsList: ADN_PLUS;
  recipients: any = [{ value: "" }];
  recipientsLimit: number;
  fieldToSet: string;
  pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  btnClass: string;

  constructor() {
    super();
  }

  startOnCustomEvent() {
    if (this.recipients[0] == '' || !this.recipients[0]) {
      this.plusAlertService.setCtDialogInfo('ERROR','downloadError','downloadError','primary','Debe ingresar un correo',true,'Aceptar','Cancelar');
    } 
    else {
      let validRecipients = [];
  
      for (let email of this.recipients) {
        if (email) {
            validRecipients.push(email);
          } 
        }
      this.recipients = validRecipients;

      let emailForm = this.utilService.getComponentRef(this.getId());
      emailForm.event2('onCustomEvent');
    }
  }
  

  addRecipient() {
    if (this.recipients.length <= this.recipientsLimit) {
      this.recipients.push({ value: "" });
    } else {
      throw new PlusException(`Este envío esta limitado a ${this.recipientsLimit + 1} destinatarios.`, 'PLUS_MAX_DEST');
    }
  }

  removeRecipient(index: any) {
    this.recipients.splice(index, 1);
  }

  bindRecipientsToAnd(): any {
    this.ADNRecipientsList = new ADN_PLUS();
    for (let i = 0; i < this.recipients.length; i++) {
      this.ADNRecipientsList.addAttribute('EMAIL_' + i, this.recipients[i].value, 1);
    }
  }

  bindAdnToRecipients(adn: ADN_PLUS): void {
    adn = new ADN_PLUS(adn);
    let val = adn.getStringAttribute(this.fieldToSet);
    if (val)
      this.recipients[0].value = val;
  }

  clear(): void {
    this.recipients = [{ value: "" }];
  }

  setRecipientsLimit(recipientsLimit): void { this.recipientsLimit = recipientsLimit }
  setADNRecipientsList(ADNRecipientsList): void { this.ADNRecipientsList = ADNRecipientsList }
  setFieldToSet(fieldToSet): void { this.fieldToSet = fieldToSet }
  setBtnClass(btnClass): void { this.btnClass = btnClass }

  getPattern(): RegExp { return this.pattern }
  getRecipientsLimit(): number { return this.recipientsLimit }
  getADNRecipientsList(): ADN_PLUS { this.bindRecipientsToAnd(); return this.ADNRecipientsList }
  getFieldToset(): string { return this.fieldToSet }
  getBtnClass(): string { return this.btnClass }
}
